import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import hmcprivacyClause from '@/components/hmcprivacyClause'
import hmcuserAgreement from '@/components/hmcuserAgreement'
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/login',
            name: 'Login',
            component: Login,
            meta: 10
        },
        {
            path: '/hmcprivacyClause',
            name: 'hmcprivacyClause',
            component: hmcprivacyClause,
            meta: {
                title: "运满车隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/hmcuserAgreement',
            name: 'hmcuserAgreement',
            component: hmcuserAgreement,
            meta: {
                title: "运满车用户协议",
                content: 'disable'
            }
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js